<template>
  <div class="page">
      <div style="padding: 30px 15px;">
          <div v-if="user != null">
              <div>姓名：{{user.name}}</div>
              <div>
                  <span>用户ID：{{user.emplId}}</span>
                  <button class="van-button van-button--primary van-button--small" style="margin-left:10px;height: 20px;line-height: 18px;" v-clipboard="copyUserWechatId" @success="copyCallback(true)" @error="copyCallback(false)">复制用户ID</button>
              </div>
          </div>
          <van-button type="primary" size="small" @click="openChoose" style="margin-top: 10px;">重新选择</van-button>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Dialog, Toast, Button } from 'vant';
  import * as dd from 'dingtalk-jsapi/entry/union';
  import ddBizContactChoose from 'dingtalk-jsapi/api/biz/contact/choose';
  import { getJsApiConfig } from '@/api/dingtalk'
  import VueClipboards from 'vue-clipboards';

  Vue.use(Dialog)
        .use(Toast)
        .use(Button)

  Vue.use(VueClipboards);

  export default {
    name: 'leader-get_userid',
    components: {

    },
    data () {
      return {
        user: null
      }
    },
    computed: {
      copyUserWechatId() {
        if (this.user) {
          return this.user.emplId;
        }
        return null;
      }
    },
    methods: {
      openChoose() {
        const vm = this;
        this.user = null;

        ddBizContactChoose({
          multiple: false,
          corpId: vm.$store.state.ddConfig.corpId,
          onSuccess: function(data) {
            vm.user = data[0];
          },
          onFail : function(err) {
            Dialog.alert({
              title: '获取失败',
              message: JSON.stringify(err)
            })
          }
        });
      },
      copyCallback(success) {
        if (success) {
          Toast('复制成功');
        } else {
          Toast('复制失败，请长按文本复制');
        }
      }
    },
    mounted() {
      const vm = this;

      const url = location.href.replace(window.location.hash, '');

      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      getJsApiConfig(url).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          const conf = data.config;

          dd.config({
            agentId: conf.agentId,
            corpId: conf.corpId,
            timeStamp: conf.timeStamp,
            nonceStr: conf.nonceStr,
            signature: conf.signature,
            type: 0,
            jsApiList : [
              'biz.contact.choose'
            ]
          });

          dd.ready(function() {
            vm.openChoose()
          });

          dd.error(function(error){
            Dialog.alert({
              title: '钉钉配置错误',
              message: JSON.stringify(error),
              confirmButtonText: '刷新试试',
            }).then(() => {
              window.location.reload(true)
            })
          });

        } else {
          Dialog.alert({
            title: '获取jsapi配置失败',
            message: data.msg
          })
        }
      });


    }
  }
</script>

<style lang="less" scoped>


</style>
